var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.elemHeight })},[_c('ag-pdfviewer-paginator'),(_vm.layoutActive)?_c('ag-layout-tools',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideLayoutToolbar),expression:"!hideLayoutToolbar"}]}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }